import type { TClass, TLevel, TPhase, TPhaseGroup } from 'types/classAndPhases'

import { KESETARAAN_PHASE_PACKET_MAPPING } from 'data/classAndPhases'

import { removeDuplicate } from './array'

export const getClassesByPhase = (phases: TPhase[]): TClass[] => {
  let classes = []
  if (phases?.includes('Fondasi')) {
    classes = [...classes, 'PAUD']
  }
  if (phases?.includes('A')) {
    classes = [...classes, 'Kelas 1', 'Kelas 2']
  }
  if (phases?.includes('B')) {
    classes = [...classes, 'Kelas 3', 'Kelas 4']
  }
  if (phases?.includes('C')) {
    classes = [...classes, 'Kelas 5', 'Kelas 6']
  }
  if (phases?.includes('D')) {
    classes = [...classes, 'Kelas 7', 'Kelas 8', 'Kelas 9']
  }
  if (phases?.includes('E')) {
    classes = [...classes, 'Kelas 10']
  }
  if (phases?.includes('F')) {
    classes = [...classes, 'Kelas 11', 'Kelas 12']
  }
  return classes
}

export const getLevelsByPhaseAndPhaseGroup = ({
  phases = [],
  phaseGroup,
}: {
  phases: TPhase[]
  phaseGroup: TPhaseGroup
}): TLevel[] => {
  let levels = []

  if (phaseGroup === 'Kesetaraan') {
    phases?.forEach((phase) => {
      levels = [...levels, `Paket ${KESETARAAN_PHASE_PACKET_MAPPING[phase]}`]
    })
    return removeDuplicate(levels)
  }

  if (phases?.includes?.('Fondasi')) levels = [...levels, 'PAUD']
  if (phases?.some?.((phase) => ['A', 'B', 'C'].includes(phase)))
    levels = [...levels, 'SD']
  if (phases?.includes?.('D')) levels = [...levels, 'SMP']
  if (phases?.some?.((phase) => ['E', 'F'].includes(phase)))
    levels = [...levels, phaseGroup === 'SMK' ? 'SMK' : 'SMA']

  return levels
}
